export enum EmailPurposeEnum {
  VERIFICATION = 'VERIFICATION',
  RESET_PASSWORD = 'RESET_PASSWORD',
}

export enum CarCardButtonType {
  RENT_NOW = 'RENT_NOW',
  BOOKING_RECORD = 'BOOKING_RECORD',
}
